import * as Yup from 'yup';
import { Validator } from '../../../shared/constants/validator';

type TranslateFunction = (key: string) => string;

export const createAddContractorContactValidationSchema = (t: TranslateFunction) =>
    Yup.object({
        contactTypeId: Yup.string().required(t('addContractorContact.REQUIRED_CONTACT_TYPE')),

        title: Yup.string(),

        firstName: Yup.string().trim().required(t('addContractorContact.REQUIRED_FIRST_NAME')),

        lastName: Yup.string().trim().required(t('addContractorContact.REQUIRED_LAST_NAME')),

        phone: Yup.string()
            .trim()
            .matches(Validator.phoneNumberRegExp, t('addContractorContact.INVALID_PHONE'))
            .required(t('addContractorContact.REQUIRED_PHONE')),

        mobile: Yup.string(),

        email: Yup.string()
            .trim()
            .email(t('addContractorContact.INVALID_EMAIL'))
            .required(t('addContractorContact.REQUIRED_EMAIL')),

        languageId: Yup.string(),

        country: Yup.string(),

        comments: Yup.string(),

        communicationAccepted: Yup.boolean(),
    });
